import { api } from "./client";

export interface SystemSettings {
  id: string;
  defaultQuotaBytes: string;
  updatedAt: string;
}

export async function getSettings(): Promise<SystemSettings> {
  return api.get("/settings");
}

export async function updateDefaultQuota(
  quotaBytes: string
): Promise<SystemSettings> {
  return api.patch("/settings/quota", { quotaBytes });
}
